import { Overlay2 } from "@blueprintjs/core";

import "./ShopOverlay.css"
import { useSelectionContext, useCartContext } from "../../hooks";
import { initialSelectionState } from "../../resources";

export function ShopOverlay({
  isOpen,
  setIsOpen,
  handleTemplateShopClick
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  handleTemplateShopClick: () => void;
}) {
  const {setCartState} = useCartContext()
  const {setSelectionState} = useSelectionContext()

  function handleNewShopClick() {
    localStorage.setItem('isShop', "T")
    setCartState({})
    setSelectionState(initialSelectionState)
    setIsOpen(false)
  }

  function handleTemplateClick() {
    setIsOpen(false)
    handleTemplateShopClick()
  }

  return (
    <>
      {isOpen && <Overlay2 isOpen={isOpen} className={!isOpen ? "" : "modalOverlay"} hasBackdrop={true}>
        <div className="modalContainer">
          <div className="shopOverlay">
            <h1>How would you like to shop ?</h1>
            <div className="shopInfo">
              <div className="shopInfoOption" onClick={handleNewShopClick}>
                <h4>New -</h4>
                <p>Create a shop from scratch</p>
              </div>
              <div className="shopInfoOption" onClick={handleTemplateClick}>
                <h4>Template -</h4>
                <p>Populate from a template</p>
              </div>
            </div>
          </div>
        </div>
      </Overlay2>}
    </>
  );
}
